/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { DialogService } from 'nebula-ui-kit';
import { map, Observable } from 'rxjs';
import { SelectDialogComponent } from '../../../select-dialog/select-dialog.component';
import { CityService } from './ciudades.service';
import { CityModal } from '../../domain/ciudades-modal.model';

@Injectable({
  providedIn: 'root',
})
export class CityModalService {
  readonly dialogService = inject(DialogService);
  readonly ciudadesService = inject(CityService);
  openSelector(
    title: string,
    departamento: string,
    currentValue?: string,
  ): Observable<CityModal | null> {
    const columns = [
      { key: 'codigo', label: 'Código', sortable: true, width: '30%' },
      { key: 'nombre', label: 'Nombre', sortable: true, width: '70%' },
    ];
    const loadDataFn = async (params: any): Promise<{ data: CityModal[]; total: number }> => {
      const page = params.page - 1;
      const size = params.limit || 10;
      const searchTerm = params.search || '';
      const sortColumn = params.sortColumn || '';
      const sortDirection = params.sortDirection || '';

      const response = await this.ciudadesService
        .getAllCity(page, size, departamento, searchTerm, sortColumn, sortDirection)
        .pipe(
          map((response: any) => {
            return {
              data: response.content || [],
              total: response.totalElements || 0,
            };
          }),
        )
        .toPromise();

      return response || { data: [], total: 0 };
    };

    const dialogRef = this.dialogService.open(SelectDialogComponent, {
      data: {
        title: title,
        columns: columns,
        multiSelect: false,
        searchPlaceholder: 'Buscar por código o nombre...',
        loadDataFn: loadDataFn,
        itemIdKey: 'id',
        displayKey: 'codigo',
        selectedItems: currentValue ? [{ codigo: currentValue, nombre: currentValue }] : [],
        pageSize: 10,
        pageSizeOptions: [10, 25, 50, 100],
      },
      size: 'lg',
      width: '700px',
    });

    return dialogRef
      .afterClosed()
      .pipe(map((selected: CityModal[]) => (selected && selected.length > 0 ? selected[0] : null)));
  }
}
